import { render, staticRenderFns } from "./AlarmWechatNotification.vue?vue&type=template&id=4f50f65a&scoped=true&"
import script from "./AlarmWechatNotification.vue?vue&type=script&lang=js&"
export * from "./AlarmWechatNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50f65a",
  null
  
)

export default component.exports